export default __webpack_public_path__ + "static/media/linea.f0be33dc.svg";